import { colors, screen } from 'components/styles/variables';
import { ReactNode } from 'react';

interface CaptionProps {
  children: ReactNode;
}

export default function Caption({ children }: CaptionProps): JSX.Element {
  return (
    <figcaption className="caption">
      {children}
      <style jsx>
        {`
          .caption {
            align-items: center;
            display: flex;
            flex-direction: row;
            padding-left: 16px;
            padding-right: 16px;
            justify-content: space-between;
            border-top: 1px solid ${colors.G2};
            height: 60px;
          }

          @media screen and (min-width: ${screen.smMin}) {
            .caption {
              height: 64px;
            }
          }
        `}
      </style>
    </figcaption>
  );
}
